/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'
import * as Yup from "yup";

import { StepperComponent } from '../../../../../../_metronic/assets/ts/components'
import { useToast } from '../../../Toats'
import { KTSVG, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { LoadingSpan } from '../../../Loadings/loadingSpan'
import { useFormik } from 'formik';
import { postPrognosisOne, putPlantOne, putPrognosisOne } from '../../../../../services/plantsService';
import useSize from '../../../../../hooks/useSize';
import { useAuth } from '../../../../../modules/auth';
import { MapsV2Plant } from '../../../../dashboard/MapsV2Plant';
import axios from 'axios';
import { ModalExportDataPrognosis } from './components/modalExportDataPrognosis';

type Props = {
    id: string;
    data: any;
    show: boolean;
    handleClose: () => void
}

const isCoordValueEmpty = (value: unknown) =>
  value === '' || value === null || value === undefined;

const COORD_MSG_LAT = 'Latitude inválida. Use valores entre -90 e 90.';
const COORD_MSG_LON = 'Longitude inválida. Use valores entre -180 e 180.';

/** Mesmas regras do Yup, aplicadas ao texto antes de atualizar o formik (evita mapa com valores inválidos). */
const validateCoordDraftLat = (value: string): string | null => {
  const t = value.trim();
  if (t === '') return null;
  const n = parseFloat(t.replace(',', '.'));
  if (Number.isNaN(n)) return COORD_MSG_LAT;
  if (n < -90 || n > 90) return COORD_MSG_LAT;
  return null;
};

const validateCoordDraftLon = (value: string): string | null => {
  const t = value.trim();
  if (t === '') return null;
  const n = parseFloat(t.replace(',', '.'));
  if (Number.isNaN(n)) return COORD_MSG_LON;
  if (n < -180 || n > 180) return COORD_MSG_LON;
  return null;
};

const validationSchema = Yup.object().shape({
  value_implementation: Yup.number(),
  annual_generation_forecast: Yup.number(),

  prog_abr: Yup.number(),
  prog_ago: Yup.number(),
  prog_dez: Yup.number(),
  prog_fev: Yup.number(),
  prog_jan: Yup.number(),
  prog_jul: Yup.number(),
  prog_jun: Yup.number(),
  prog_mar: Yup.number(),
  prog_may: Yup.number(),
  prog_nov: Yup.number(),
  prog_oct: Yup.number(),
  prog_sep: Yup.number(),

  plantLat: Yup.mixed()
    .nullable()
    .test(
      'plantLat',
      COORD_MSG_LAT,
      (value) => {
        if (isCoordValueEmpty(value)) return true;
        const n = typeof value === 'number' ? value : parseFloat(String(value));
        if (Number.isNaN(n)) return false;
        return n >= -90 && n <= 90;
      },
    ),

  plantLon: Yup.mixed()
    .nullable()
    .test(
      'plantLon',
      COORD_MSG_LON,
      (value) => {
        if (isCoordValueEmpty(value)) return true;
        const n = typeof value === 'number' ? value : parseFloat(String(value));
        if (Number.isNaN(n)) return false;
        return n >= -180 && n <= 180;
      },
    ),
});


const modalsRoot = document.getElementById('root-modals') || document.body

const ModalUpdatePlant = ({show, handleClose, id, data}: Props) => {

  const { toggleToast } = useToast();
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [loading, setLoading] = useState(false)
  const {currentUser} = useAuth()
  const [showCreateAppModalExport, setShowCreateAppModalExport] = useState<boolean>(false)

  const inputRef = useRef(null);
  const [address, setAddress] = useState("");


  const [initialValues] = useState<any>({
    value_implementation: data.value_implementation ? data.value_implementation : 0,
    annual_generation_forecast: data.annual_generation_forecast ? data.annual_generation_forecast : 0,
    
    plantName: data && data.plantName ? data.plantName : null,
    capacity: data && data.capacity ? data.capacity : null,
    plano: data && data.plano ? data.plano : null,
    
    address: data && data.address ? data.address : null,
    addressReduce: data && data.addressReduce ? data.addressReduce : null,

    plantLat: data && data.plantLat ? data.plantLat : null,
    plantLon: data && data.plantLon ? data.plantLon : null,

    

    number_panels : data.number_panels ? data.number_panels : 0,
    description_kit_instalation : data.description_kit_instalation ? data.description_kit_instalation : null,
    tensao : data.tensao ? data.tensao : 0,
    tensao_v2 : data.tensao_v2 ? data.tensao_v2 : 0,
    type_conection : data.type_conection ? data.type_conection : null,
    type_conection_v2 : data.type_conection_v2 ? data.type_conection_v2 : null,
    economy_total_year : data.economy_total_year ? data.economy_total_year : 0,

    prog_abr: data && data.prognosis && data.prognosis.prog_abr ? data.prognosis.prog_abr : 0,
    prog_ago: data && data.prognosis && data.prognosis.prog_ago ? data.prognosis.prog_ago : 0,
    prog_dez: data && data.prognosis && data.prognosis.prog_dez ? data.prognosis.prog_dez : 0,
    prog_fev: data && data.prognosis && data.prognosis.prog_fev ? data.prognosis.prog_fev : 0,
    prog_jan: data && data.prognosis && data.prognosis.prog_jan ? data.prognosis.prog_jan : 0,
    prog_jul: data && data.prognosis && data.prognosis.prog_jul ? data.prognosis.prog_jul : 0,
    prog_jun: data && data.prognosis && data.prognosis.prog_jun ? data.prognosis.prog_jun : 0,
    prog_mar: data && data.prognosis && data.prognosis.prog_mar ? data.prognosis.prog_mar : 0,
    prog_may: data && data.prognosis && data.prognosis.prog_may ? data.prognosis.prog_may : 0,
    prog_nov: data && data.prognosis && data.prognosis.prog_nov ? data.prognosis.prog_nov : 0,
    prog_oct: data && data.prognosis && data.prognosis.prog_oct ? data.prognosis.prog_oct : 0,
    prog_sep: data && data.prognosis && data.prognosis.prog_sep ? data.prognosis.prog_sep : 0,
  })
  const {width} = useSize()
  
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const closed = () => {
    handleClose()
  }

  const updatePlantSubmit = async () => {
    try {
      setLoading(true)
      const body = {
        value_implementation: formik.values.value_implementation,
        annual_generation_forecast: formik.values.annual_generation_forecast,

        plantName: formik.values.plantName ? formik.values.plantName : null,
        capacity: formik.values.capacity ? formik.values.capacity : null,
        plano: formik.values.plano ? formik.values.plano : null,
        
        address: formik.values.address ? formik.values.address : null,
        addressReduce: formik.values.addressReduce ? formik.values.addressReduce : null,

        plantLat: formik.values.plantLat ? formik.values.plantLat : null,
        plantLon: formik.values.plantLon ? formik.values.plantLon : null,

        number_panels : formik.values.number_panels ? formik.values.number_panels : 0,
        description_kit_instalation : formik.values.description_kit_instalation ? formik.values.description_kit_instalation : null,
        tensao : formik.values.tensao ? formik.values.tensao : 0,
        tensao_v2: formik.values.tensao_v2 ? formik.values.tensao_v2 : 0,
        type_conection : formik.values.type_conection ? formik.values.type_conection : null,
        type_conection_v2 : formik.values.type_conection_v2 ? formik.values.type_conection_v2 : null,
        economy_total_year : formik.values.economy_total_year ? formik.values.economy_total_year : 0,
      };

      const bodyV2 = {
        prog_abr: formik.values.prog_abr ? formik.values.prog_abr : 0,
        prog_ago: formik.values.prog_ago ? formik.values.prog_ago : 0,
        prog_dez: formik.values.prog_dez ? formik.values.prog_dez : 0,
        prog_fev: formik.values.prog_fev ? formik.values.prog_fev : 0,
        prog_jan: formik.values.prog_jan ? formik.values.prog_jan : 0,
        prog_jul: formik.values.prog_jul ? formik.values.prog_jul : 0,
        prog_jun: formik.values.prog_jun ? formik.values.prog_jun : 0,
        prog_mar: formik.values.prog_mar ? formik.values.prog_mar : 0,
        prog_may: formik.values.prog_may ? formik.values.prog_may : 0,
        prog_nov: formik.values.prog_nov ? formik.values.prog_nov : 0,
        prog_oct: formik.values.prog_oct ? formik.values.prog_oct : 0,
        prog_sep: formik.values.prog_sep ? formik.values.prog_sep : 0,
        idPlant: id ? id : ""
      }
      await putPlantOne(id, body);
      
      if(data && data.prognosis){
        await putPrognosisOne(data.prognosis.id, bodyV2);
      }else{
        await postPrognosisOne(bodyV2)
      }
      

      toggleToast("Sucesso ao atualizar as informaçoes usina. ", "success")

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao atualizar as informações da usina. ", "error")
    }finally{
      setLoading(false)
      closed()
      // handleClose()
    //   setTimeout(()=>{
    //     window.location.reload()
    //   }, 2000);
    }
  }

  const dividerValues = () => {
    const value = formik.values.annual_generation_forecast;
    if(value){
      const value_mes = Number((value/12).toFixed(2));

      formik.setValues({
        ...formik.values,
        prog_abr: value_mes,
        prog_ago: value_mes,
        prog_dez: value_mes,
        prog_fev: value_mes,
        prog_jan: value_mes,
        prog_jul: value_mes,
        prog_jun: value_mes,
        prog_mar: value_mes,
        prog_may: value_mes,
        prog_nov: value_mes,
        prog_oct: value_mes,
        prog_sep: value_mes
      })
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: async () => {
      await updatePlantSubmit();
    },
  });

  const handleUpdatePlantClick = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setTouched({
        ...formik.touched,
        ...Object.fromEntries(Object.keys(errors).map((key) => [key, true])),
      });
      return;
    }
    await updatePlantSubmit();
  };

  const [coordsEditMode, setCoordsEditMode] = useState(false);
  const [draftLat, setDraftLat] = useState('');
  const [draftLon, setDraftLon] = useState('');
  const [coordsDraftErrors, setCoordsDraftErrors] = useState<{
    lat?: string;
    lon?: string;
  }>({});

  const startCoordsEdit = () => {
    setDraftLat(
      !isCoordValueEmpty(formik.values.plantLat)
        ? String(formik.values.plantLat)
        : '',
    );
    setDraftLon(
      !isCoordValueEmpty(formik.values.plantLon)
        ? String(formik.values.plantLon)
        : '',
    );
    setCoordsDraftErrors({});
    setCoordsEditMode(true);
  };

  const cancelCoordsEdit = () => {
    setCoordsEditMode(false);
    setDraftLat('');
    setDraftLon('');
    setCoordsDraftErrors({});
  };

  const applyCoordDrafts = () => {
    const errLat = validateCoordDraftLat(draftLat);
    const errLon = validateCoordDraftLon(draftLon);
    if (errLat || errLon) {
      setCoordsDraftErrors({
        lat: errLat ?? undefined,
        lon: errLon ?? undefined,
      });
      return;
    }
    const latTrim = draftLat.trim();
    const lonTrim = draftLon.trim();
    const plantLat = latTrim === '' ? '' : parseFloat(latTrim.replace(',', '.'));
    const plantLon = lonTrim === '' ? '' : parseFloat(lonTrim.replace(',', '.'));
    formik.setValues({
      ...formik.values,
      plantLat,
      plantLon,
    });
    const cleared = {...formik.errors};
    delete cleared.plantLat;
    delete cleared.plantLon;
    formik.setErrors(cleared);
    setCoordsDraftErrors({});
    setCoordsEditMode(false);
  };

  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const fetchSuggestions = async (input) => {
    if (input.length < 3) return;

    try {
      const response = await axios.get(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
          input
        )}.json`,
        {
          params: {
            access_token: "pk.eyJ1IjoibGVra293aWxsaWFtdG9ycmVzIiwiYSI6ImNsdThnazlyZDBmcXEya29qMmZndGtmMmkifQ.kwHp_K24hVrkVHWqTE9yEQ",
            autocomplete: true,
            types: "place,address",
            language: "pt-BR",
          },
        }
      );

      setSuggestions(response.data.features || []);
    } catch (error: any) {
      console.error("Erro ao buscar sugestões:", error.response?.data || error.message);
    }
  };

  function isValidCoordinate(value, min, max) {
    const num = parseFloat(value);
    return !isNaN(num) && num >= min && num <= max;
}

const getStateAndCountry = async (latitude, longitude) => {
  if (
    !isValidCoordinate(latitude, -90, 90) ||
    !isValidCoordinate(longitude, -180, 180)
  ) {
    console.error("Coordenadas inválidas:", { latitude, longitude });
    return null;
  }

  try {
    const response = await axios.get(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json`,
      {
        params: {
          access_token:
            "pk.eyJ1IjoibGVra293aWxsaWFtdG9ycmVzIiwiYSI6ImNsdThnazlyZDBmcXEya29qMmZndGtmMmkifQ.kwHp_K24hVrkVHWqTE9yEQ", // Insira seu token aqui
          language: "pt-BR",
          types: "place,region,country",
        },
      }
    );

    if (response.data && response.data.features) {
      const features = response.data.features;

      const cityFeature = features.find((feature) =>
        feature.place_type.includes("place")
      );
      const stateFeature = features.find((feature) =>
        feature.place_type.includes("region")
      );
      const countryFeature = features.find((feature) =>
        feature.place_type.includes("country")
      );

      const city = cityFeature ? cityFeature.text : "Cidade não encontrada";
      const state = stateFeature ? stateFeature.text : "Estado não encontrado";
      const country = countryFeature
        ? countryFeature.text
        : "País não encontrado";

      formik.setValues({
        ...formik.values, addressReduce: `${city}, ${state}, ${country}`});

      return { city, state, country };
    }

    console.warn("Nenhum dado encontrado para as coordenadas:", {
      latitude,
      longitude,
    });
    return null;
  } catch (error: any) {
    console.error(
      "Erro na chamada da API:",
      error.response?.data || error.message
    );
    return null;
  }
};



  useEffect(() => {
    formik.setValues({
      value_implementation: data && data.value_implementation ? data.value_implementation : 0,
      annual_generation_forecast: data && data.annual_generation_forecast ? data.annual_generation_forecast : 0,
      
      plantId: data && data.plantId ? data.plantId : "",
      plantName: data && data.plantName ? data.plantName : "",
      capacity: data && data.capacity ? data.capacity : "",
      plano: data && data.plano ? data.plano : "",
      
      address: data && data.address ? data.address : "",
      addressReduce: data && data.addressReduce ? data.addressReduce : null,

      plantLat: data && data.plantLat ? data.plantLat : "",
      plantLon: data && data.plantLon ? data.plantLon : "",


      number_panels : data.number_panels ? data.number_panels : 0,
      description_kit_instalation : data.description_kit_instalation ? data.description_kit_instalation : null,
      tensao : data.tensao ? data.tensao : 0,
      tensao_v2 : data.tensao_v2 ? data.tensao_v2 : 0,
      type_conection : data.type_conection ? data.type_conection : null,
      type_conection_v2 : data.type_conection_v2 ? data.type_conection_v2 : null,
      economy_total_year : data.economy_total_year ? data.economy_total_year : 0,


      prog_abr: data && data.prognosis && data.prognosis.prog_abr ? data.prognosis.prog_abr : 0,
      prog_ago: data && data.prognosis && data.prognosis.prog_ago ? data.prognosis.prog_ago : 0,
      prog_dez: data && data.prognosis && data.prognosis.prog_dez ? data.prognosis.prog_dez : 0,
      prog_fev: data && data.prognosis && data.prognosis.prog_fev ? data.prognosis.prog_fev : 0,
      prog_jan: data && data.prognosis && data.prognosis.prog_jan ? data.prognosis.prog_jan : 0,
      prog_jul: data && data.prognosis && data.prognosis.prog_jul ? data.prognosis.prog_jul : 0,
      prog_jun: data && data.prognosis && data.prognosis.prog_jun ? data.prognosis.prog_jun : 0,
      prog_mar: data && data.prognosis && data.prognosis.prog_mar ? data.prognosis.prog_mar : 0,
      prog_may: data && data.prognosis && data.prognosis.prog_may ? data.prognosis.prog_may : 0,
      prog_nov: data && data.prognosis && data.prognosis.prog_nov ? data.prognosis.prog_nov : 0,
      prog_oct: data && data.prognosis && data.prognosis.prog_oct ? data.prognosis.prog_oct : 0,
      prog_sep: data && data.prognosis && data.prognosis.prog_sep ? data.prognosis.prog_sep : 0,
    })
    setCoordsEditMode(false);
    setDraftLat('');
    setDraftLon('');
    setCoordsDraftErrors({});
   }, [show]);

   useEffect(() => {
    if(
      (formik.values.prog_abr !== undefined && formik.values.prog_abr !== '' && formik.values.prog_abr !== null) &&
      (formik.values.prog_ago !== undefined && formik.values.prog_ago !== '' && formik.values.prog_ago !== null) &&
      (formik.values.prog_dez !== undefined && formik.values.prog_dez !== '' && formik.values.prog_dez !== null) &&
      (formik.values.prog_fev !== undefined && formik.values.prog_fev !== '' && formik.values.prog_fev !== null) &&
      (formik.values.prog_jan !== undefined && formik.values.prog_jan !== '' && formik.values.prog_jan !== null) &&
      (formik.values.prog_jul !== undefined && formik.values.prog_jul !== '' && formik.values.prog_jul !== null) &&
      (formik.values.prog_jun !== undefined && formik.values.prog_jun !== '' && formik.values.prog_jun !== null) &&
      (formik.values.prog_mar !== undefined && formik.values.prog_mar !== '' && formik.values.prog_mar !== null) &&
      (formik.values.prog_may !== undefined && formik.values.prog_may !== '' && formik.values.prog_may !== null) &&
      (formik.values.prog_nov !== undefined && formik.values.prog_nov !== '' && formik.values.prog_nov !== null) &&
      (formik.values.prog_oct !== undefined && formik.values.prog_oct !== '' && formik.values.prog_oct !== null) &&
      (formik.values.prog_sep !== undefined && formik.values.prog_sep !== '' && formik.values.prog_sep !== null)
    ){
      formik.setValues({...formik.values, annual_generation_forecast : 
        Number((formik.values.prog_abr
        + formik.values.prog_ago
        + formik.values.prog_dez
        + formik.values.prog_fev
        + formik.values.prog_jan
        + formik.values.prog_jul
        + formik.values.prog_jun
        + formik.values.prog_mar
        + formik.values.prog_may
        + formik.values.prog_nov
        + formik.values.prog_oct
        + formik.values.prog_sep).toFixed(2))
      })
    }
   }, [
    formik.values.prog_abr,
    formik.values.prog_ago,
    formik.values.prog_dez,
    formik.values.prog_fev,
    formik.values.prog_jan,
    formik.values.prog_jul,
    formik.values.prog_jun,
    formik.values.prog_mar,
    formik.values.prog_may,
    formik.values.prog_nov,
    formik.values.prog_oct,
    formik.values.prog_sep,
   ]);


   useEffect(() => {
    
    if(formik.values.plantLat
      && formik.values.plantLon
    ){

      getStateAndCountry(formik.values.plantLat, formik.values.plantLon)
    }

   }, [
    formik.values.plantLat, 
    formik.values.plantLon
  ])


  // useEffect(() => {
  //   formik.setValues({...formik.values, prog_jan: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_fev: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_mar: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_abr: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_may: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_jun: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_jul: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_ago: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_sep: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_oct: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_nov: formik.values.annual_generation_forecast / 12})
  //   formik.setValues({...formik.values, prog_dez: formik.values.annual_generation_forecast / 12})

  // }, [formik.values.annual_generation_forecast])


  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-fullscreen'
      className='modal-stacked'
      backdropClassName='modal-backdrop-stacked'
      show={show}
      onHide={closed}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Configurações da Usina {" - "}{data && data.name ? data.name : "Não identificado"}</span>
          {/* <span className='text-muted mt-1 fw-semibold fs-5'>( {unitBranch.name} )</span> */}
        </h3>

        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
        {/* end::Close */}
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {/*begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
         
          {/*begin::Content */}
          <div className='flex-row-fluid py-lg-0'>
            <div style={{display: 'flex', gap: '4rem', alignItems: 'center', width: '100%', justifyContent: 'space-between'}}>
             
              <div style={{flex: '1'}}>
                <div className='fv-row' style={{marginBottom: '1.5rem'}}>
                    <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                        <span>ID da usina no Solar Vision</span>
                        <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Id da usina'
                        ></i>
                    </label>
                    <input
                        type='text'
                        disabled={true}
                        className='form-control form-control-lg'
                        name='id_usina'
                        placeholder=''
                        value={formik.values.plantId}
                        onChange={formik.handleChange("plantId")}
                    />
                  </div>

                  <div style={{display: 'flex', gap: '0.5rem', flexWrap: 'wrap'}}>
                    <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1', minWidth: '15rem'}}>
                      <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Nome da usina</span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Nome da usina'
                          ></i>
                      </label>
                      <input
                          type='text'
                          //disabled={data && data.plano && data.plano !== "PREMIUM" ? true : false}
                          className='form-control form-control-lg'
                          name='plantName'
                          placeholder=''
                          value={formik.values.plantName}
                          onChange={formik.handleChange("plantName")}
                      />
                    </div>
                    <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1', minWidth: '15rem'}}>
                      <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Plano da usina</span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Valor da implantação da usina'
                          ></i>
                      </label>
                      <select
                          //style={{width: width < 1200 ? '100%' : '20rem'}}
                          className='form-select form-select-solid'
                          data-kt-select2='true'
                          data-placeholder='Select option'
                          data-allow-clear='true'
                          defaultValue={''}
                          value={formik.values.plano}
                          onChange={(e) => {
                            formik.setValues({...formik.values, plano: e.target.value})
                          }}
                        >
                          <option value={''} disabled>Selecione um plano</option>
                          {
                            currentUser 
                            && currentUser.companies 
                            && currentUser.companies.length > 0 
                            && currentUser.companies[0].planosCompany
                            && currentUser.companies[0].planosCompany.qtd_plants_plano > 0
                            && (
                              <option value={'PREMIUM'}>PREMIUM</option>
                            )
                          }
                          {
                            currentUser 
                            && currentUser.companies 
                            && currentUser.companies.length > 0 
                            && currentUser.companies[0].planosCompany
                            && currentUser.companies[0].planosCompany.qtd_plants_plano_starter > 0
                            && (
                              <option value={'STARTER'}>STARTER</option>
                            )
                          }

                          {
                            currentUser 
                            && currentUser.companies 
                            && currentUser.companies.length > 0 
                            && currentUser.companies[0].planosCompany
                            && currentUser.companies[0].planosCompany.qtd_plants_gratuita > 0
                            && (
                              <option value={'BASICA'}>BÁSICA</option>
                            )
                          }

                      </select>
                    </div>
                  </div>
                  

                  <div style={{display: 'flex', gap: '0.5rem', flexWrap: 'wrap'}}>
                    <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1'}}>
                      <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Potência</span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Potencia da usina'
                          ></i>
                      </label>
                      <input
                          type='number'
                          //disabled={data && data.plano && data.plano !== "PREMIUM" ? true : false}
                          className='form-control form-control-lg'
                          name='name'
                          placeholder=''
                          value={formik.values.capacity}
                          onChange={formik.handleChange("capacity")}
                      />
                    </div>


                    <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1'}}>
                      <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Tensão</span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Tensão da usina'
                          ></i>
                      </label>

                      <select
                        //style={{width: width < 1200 ? '100%' : '20rem'}}
                        className='form-select form-select-solid'
                        data-kt-select2='true'
                        data-placeholder='Select option'
                        data-allow-clear='true'
                        defaultValue={''}
                        value={formik.values.tensao_v2}
                        onChange={(e) => {
                          formik.setValues({...formik.values, tensao_v2: e.target.value})
                        }}
                      >
                        <option value={''}>Selecione uma tensão</option>
                        <option value={'110/220'}>110/220</option>
                        <option value={'115/230'}>115/230</option>
                        <option value={'120/208'}>120/208</option>
                        <option value={'120/240'}>120/240</option>
                        <option value={'127/220'}>127/220</option>
                        <option value={'220/380'}>220/380</option>
                        <option value={'220/440'}>220/440</option>
                      </select>
                      {/* <input
                          type='number'
                          //disabled={data && data.plano && data.plano !== "PREMIUM" ? true : false}
                          className='form-control form-control-lg'
                          name='name'
                          placeholder=''
                          value={formik.values.tensao_v2}
                          onChange={formik.handleChange("tensao_v2")}
                      /> */}
                    </div>

                    <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1'}}>
                      <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Quantidade de paineis</span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Potencia da usina'
                          ></i>
                      </label>
                      <input
                          type='number'
                          //disabled={data && data.plano && data.plano !== "PREMIUM" ? true : false}
                          className='form-control form-control-lg'
                          name='number_panels'
                          placeholder=''
                          value={formik.values.number_panels}
                          onChange={formik.handleChange("number_panels")}
                      />
                    </div>

                    <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1'}}>
                      <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Tipo de conexão</span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Tipo de conexão da usina'
                          ></i>
                      </label>
                      <select
                        //style={{width: width < 1200 ? '100%' : '20rem'}}
                        className='form-select form-select-solid'
                        data-kt-select2='true'
                        data-placeholder='Select option'
                        data-allow-clear='true'
                        defaultValue={''}
                        value={formik.values.type_conection_v2}
                        onChange={(e) => {
                          formik.setValues({...formik.values, type_conection_v2: e.target.value})
                        }}
                      >
                        <option value={''} disabled>Selecione uma conexão</option>
                        <option value={'monofasico'}>Monofásico</option>
                        <option value={'bifasico'}>Bifásico</option>
                        <option value={'trifasico'}>Trifásico</option>
                      </select>
                  </div>
                  </div>
              </div>

              <div>
                <div 
                  className={`symbol symbol-${width < 1200 ? '150px' : '150px'} symbol-fixed position-relative divSubImg`} 
                >
                  <img src={toAbsoluteUrl('/media/imgs/plant2.png')} alt='Metornic' />
                  <div 
                    className={
                      `position-absolute translate-middle bottom-0 start-100 mb-6 bg-${
                        data.status !== null
                          ? data.status === 0
                          ? "success"
                          : data.status === 1
                          ? "danger"
                          : data.status === 2
                          ? "warning"
                          : data.status === 7 || data.status === 3
                          ? "info"
                          : "secondary"
                        : "secondary"
                      
                      } rounded-circle border border-4 border-white h-20px w-20px`}
                  ></div>

                </div>
              </div>

            </div>
            <div style={{marginBottom: '3rem'}}>
                <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1'}}>
                  <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                      <span>Descrição do Kit instalado</span>
                      <i
                      className='fas fa-exclamation-circle ms-2 fs-7'
                      data-bs-toggle='tooltip'
                      title='Descrição do kit instalado na usina'
                      ></i>
                  </label>
                  <input
                      type='text'
                      style={{height: '15rem'}}
                      className='form-control form-control-lg'
                      name='description_kit_instalation'
                      placeholder=''
                      value={formik.values.description_kit_instalation}
                      onChange={formik.handleChange("description_kit_instalation")}
                  />
                </div>
                
                <div style={{display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap'}}>
                  
                  <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1'}}>
                    <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                        <span>Total investido (R$)</span>
                        <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Valor da implantação da usina'
                        ></i>
                    </label>
                    <input
                        type='number'
                        disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                        className='form-control form-control-lg'
                        name='value_implementation'
                        placeholder=''
                        value={formik.values.value_implementation}
                        onChange={formik.handleChange("value_implementation")}
                    />
                  </div>

                  <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1'}}>
                    <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                        <span>Economia total estimada - 25 anos (R$)</span>
                        <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Economia da usina nos proximos 25 anos'
                        ></i>
                    </label>
                    <input
                        type='number'
                        disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                        className='form-control form-control-lg'
                        name='economy_total_year'
                        placeholder=''
                        value={formik.values.economy_total_year}
                        onChange={formik.handleChange("economy_total_year")}
                    />
                  </div>
                  
                </div>

                <div className='fv-row' style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                  <label className='d-flex align-items-center fs-6 fw-semibold mb-2' style={{flex: width < 1200 ? 1 : 5}}>
                      <span>Geração Anual Prevista (KWh)</span>
                      <i
                      className='fas fa-exclamation-circle ms-2 fs-7'
                      data-bs-toggle='tooltip'
                      title='Valor da implantação da usina'
                      ></i>
                  </label>
                  <div style={{flex: 1, display: 'flex', gap: '0.7rem', alignItems: 'center'}}>
                    <input
                        type='number'
                        disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                        className='form-control form-control-lg'
                        name='annual_generation_forecast'
                        placeholder=''
                        value={formik.values.annual_generation_forecast}
                        onChange={formik.handleChange("annual_generation_forecast")}
                    />
                    <button
                        type='button'
                        disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                        className='btn btn-sm btn-primary'
                        //disabled={loading}
                        //data-kt-stepper-action='submit'
                        onClick={dividerValues}
                    >
                        Aplicar
                    </button>

                    <button 
                      className='btn btn-sm btn-icon btn-active-color-primary' 
                      onClick={() => {setShowCreateAppModalExport(true)}}
                      disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                    >
                      <div>
                        <KTSVG className='svg-icon-2x' path='/media/icons/duotune/arrows/arr078.svg' />
                      </div>
                    </button>
                    

                  </div>
                </div>

                <div className='fv-row mt-5' style={{display: 'flex', flexDirection: 'column', gap: '1rem', height: '20rem', overflow: 'auto'}}>
                  {/* <label className='d-flex align-items-center fs-6 fw-semibold'>
                      <span>Geração Anual Dividida por Mês (KWh)</span>
                      <i
                      className='fas fa-exclamation-circle ms-2 fs-7'
                      data-bs-toggle='tooltip'
                      title='Valor da implantação da usina'
                      ></i>
                  </label> */}
                  
                  <div style={{display: 'flex', gap: '1rem', flexWrap: width < 1200 ? 'wrap' : 'nowrap'}}>
                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Janeiro</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_jan'
                          placeholder=''
                          value={formik.values.prog_jan}
                          onChange={formik.handleChange("prog_jan")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_jan", 0);
                            }
                          }}
                      />
                    </div>

                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Fevereiro</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_fev'
                          placeholder=''
                          value={formik.values.prog_fev}
                          onChange={formik.handleChange("prog_fev")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_fev", 0);
                            }
                          }}
                      />
                    </div>

                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Março</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_mar'
                          placeholder=''
                          value={formik.values.prog_mar}
                          onChange={formik.handleChange("prog_mar")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_mar", 0);
                            }
                          }}
                      />
                    </div>
                  </div>

                  <div style={{display: 'flex', gap: '1rem', flexWrap: width < 1200 ? 'wrap' : 'nowrap'}}>
                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Abril</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_abr'
                          placeholder=''
                          value={formik.values.prog_abr}
                          onChange={formik.handleChange("prog_abr")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_abr", 0);
                            }
                          }}
                      />
                    </div>

                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Maio</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_may'
                          placeholder=''
                          value={formik.values.prog_may}
                          onChange={formik.handleChange("prog_may")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_may", 0);
                            }
                          }}
                      />
                    </div>

                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Junho</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_jun'
                          placeholder=''
                          value={formik.values.prog_jun}
                          onChange={formik.handleChange("prog_jun")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_jun", 0);
                            }
                          }}
                      />
                    </div>
                  </div>

                  <div style={{display: 'flex', gap: '1rem', flexWrap: width < 1200 ? 'wrap' : 'nowrap'}}>
                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Julho</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_jul'
                          placeholder=''
                          value={formik.values.prog_jul}
                          onChange={formik.handleChange("prog_jul")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_jul", 0);
                            }
                          }}
                      />
                    </div>
                    
                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Agosto</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_ago'
                          placeholder=''
                          value={formik.values.prog_ago}
                          onChange={formik.handleChange("prog_ago")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_ago", 0);
                            }
                          }}
                      />
                    </div>

                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Setembro</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_sep'
                          placeholder=''
                          value={formik.values.prog_sep}
                          onChange={formik.handleChange("prog_sep")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_sep", 0);
                            }
                          }}
                      />
                    </div>
                  </div>

                  <div style={{display: 'flex', gap: '1rem', flexWrap: width < 1200 ? 'wrap' : 'nowrap'}}>
                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Outubro</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_oct'
                          placeholder=''
                          value={formik.values.prog_oct}
                          onChange={formik.handleChange("prog_oct")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_oct", 0);
                            }
                          }}
                      />
                    </div>

                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Novembro</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_nov'
                          placeholder=''
                          value={formik.values.prog_nov}
                          onChange={formik.handleChange("prog_nov")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_nov", 0);
                            }
                          }}
                      />
                    </div>
                    
                    <div style={{display: 'flex', gap: '0.5rem', flex: '1'}}>
                      <label style={{width: '11rem'}} className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                          <span>Dezembro</span>
                      </label>
                      <input
                          type='number'
                          disabled={data && data.plano && data.plano !== "PREMIUM" && data.plano !== "STARTER" ? true : false}
                          className='form-control form-control-lg'
                          name='prog_dez'
                          placeholder=''
                          value={formik.values.prog_dez}
                          onChange={formik.handleChange("prog_dez")}
                          onBlur={(e) => {
                            if (e.target.value === "") {
                              formik.setFieldValue("prog_dez", 0);
                            }
                          }}
                      />
                    </div>
                  </div>
                </div>


                <div className='fv-row mt-5'>
                  <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1'}}>
                    <label className='d-flex align-items-center fs-6 fw-semibold mb-2'>
                        <span>Endereço</span>
                        <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Valor da implantação da usina'
                        ></i>
                    </label>
                    <input
                      type="text"
                      placeholder="Digite o endereço"
                      className='form-control form-control-lg'
                      name='endereco'
                      value={formik.values.address}
                      onChange={(e) => {
                        //setQuery(e.target.value);
                        formik.setValues({...formik.values, address: e.target.value})
                        fetchSuggestions(e.target.value);
                      }}
                    />
                    <ul style={{ listStyleType: "none", padding: 0, marginTop: "10px" }}>
                      {suggestions.map((suggestion: any, index) => (
                        <li
                          key={index}
                          style={{
                            padding: "10px",
                            borderBottom: "1px solid #ccc",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setQuery(suggestion.place_name);

                            formik.setValues({
                              ...formik.values, 
                              address: suggestion.place_name, 
                              plantLat: suggestion.geometry.coordinates[1], 
                              plantLon: suggestion.geometry.coordinates[0]
                            })
                            setCoordsEditMode(false);
                            setCoordsDraftErrors({});
                            setSuggestions([]);
                          }}
                        >
                          {suggestion.place_name}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div>
                    <MapsV2Plant plant={data} formik={formik}/>
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      alignItems: 'flex-start',
                      gap: '1.25rem',
                      width: '100%',
                    }}
                  >
                    <div style={{display: 'flex', gap: '2rem', flexWrap: 'wrap', flex: '1'}}>
                    <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1', display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: '15rem'}}>
                      <label className='d-flex align-items-center fs-6 fw-semibold mb-0'>
                          <span>Latitude</span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Latitude da usina (-90 a 90)'
                          ></i>
                      </label>
                      <input
                          disabled={!coordsEditMode}
                          type='number'
                          step='any'
                          readOnly={!coordsEditMode}
                          className={`form-control form-control-lg${
                            coordsEditMode && coordsDraftErrors.lat
                              ? ' is-invalid'
                              : !coordsEditMode && formik.touched.plantLat && formik.errors.plantLat
                                ? ' is-invalid'
                                : ''
                          }`}
                          name='plantLat'
                          placeholder=''
                          value={
                            coordsEditMode
                              ? draftLat
                              : formik.values.plantLat ?? ''
                          }
                          onChange={
                            coordsEditMode
                              ? (e) => {
                                  setDraftLat(e.target.value);
                                  if (coordsDraftErrors.lat) {
                                    setCoordsDraftErrors((prev) => ({
                                      ...prev,
                                      lat: undefined,
                                    }));
                                  }
                                }
                              : formik.handleChange
                          }
                          onBlur={coordsEditMode ? undefined : formik.handleBlur}
                      />
                      {coordsEditMode && coordsDraftErrors.lat ? (
                        <div className='fv-plugins-message-container invalid-feedback d-block'>
                          {coordsDraftErrors.lat}
                        </div>
                      ) : null}
                      {!coordsEditMode &&
                      formik.touched.plantLat &&
                      formik.errors.plantLat ? (
                        <div className='fv-plugins-message-container invalid-feedback d-block'>
                          {typeof formik.errors.plantLat === 'string'
                            ? formik.errors.plantLat
                            : ''}
                        </div>
                      ) : null}
                    </div>

                    <div className='fv-row' style={{marginBottom: '1.5rem', flex: '1', display: 'flex', flexDirection: 'column', gap: '0.5rem', minWidth: '15rem'}}>
                      <label className='d-flex align-items-center fs-6 fw-semibold mb-0'>
                          <span>Longitude</span>
                          <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Longitude da usina (-180 a 180)'
                          ></i>
                      </label>
                      <input
                          disabled={!coordsEditMode}
                          type='number'
                          step='any'
                          readOnly={!coordsEditMode}
                          className={`form-control form-control-lg${
                            coordsEditMode && coordsDraftErrors.lon
                              ? ' is-invalid'
                              : !coordsEditMode && formik.touched.plantLon && formik.errors.plantLon
                                ? ' is-invalid'
                                : ''
                          }`}
                          name='plantLon'
                          placeholder=''
                          value={
                            coordsEditMode
                              ? draftLon
                              : formik.values.plantLon ?? ''
                          }
                          onChange={
                            coordsEditMode
                              ? (e) => {
                                  setDraftLon(e.target.value);
                                  if (coordsDraftErrors.lon) {
                                    setCoordsDraftErrors((prev) => ({
                                      ...prev,
                                      lon: undefined,
                                    }));
                                  }
                                }
                              : formik.handleChange
                          }
                          onBlur={coordsEditMode ? undefined : formik.handleBlur}
                      />
                      {coordsEditMode && coordsDraftErrors.lon ? (
                        <div className='fv-plugins-message-container invalid-feedback d-block'>
                          {coordsDraftErrors.lon}
                        </div>
                      ) : null}
                      {!coordsEditMode &&
                      formik.touched.plantLon &&
                      formik.errors.plantLon ? (
                        <div className='fv-plugins-message-container invalid-feedback d-block'>
                          {typeof formik.errors.plantLon === 'string'
                            ? formik.errors.plantLon
                            : ''}
                        </div>
                      ) : null}
                    </div>
                    </div>

                    <div
                      className='d-flex flex-column flex-sm-row flex-xl-column gap-2'
                      style={{flexShrink: 0, paddingTop: '1.75rem'}}
                    >
                      {!coordsEditMode ? (
                        <button
                          type='button'
                          className='btn btn-sm btn-light-primary text-nowrap'
                          onClick={startCoordsEdit}
                        >
                          <i className='fas fa-edit me-2' />
                          Editar coordenadas
                        </button>
                      ) : (
                        <>
                          <button
                            type='button'
                            className='btn btn-sm btn-primary text-nowrap'
                            onClick={applyCoordDrafts}
                          >
                            Aplicar
                          </button>
                          <button
                            type='button'
                            className='btn btn-sm btn-light text-nowrap'
                            onClick={cancelCoordsEdit}
                          >
                            Cancelar
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>


            </div>
            {/*begin::Form */}
            
            {/*end::Form */}
          </div>
          {/*end::Content */}
        </div>
        {/* end::Stepper */}
      </div>

      <div className='modal-footer py-lg-10 px-lg-10'>
        <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
            <button
                type='button'
                className='btn btn-lg btn-light'
                disabled={loading}
                onClick={() => {
                    closed()
                }}
                //data-kt-stepper-action='submit'
            >
                <KTSVG
                    path='/media/icons/duotune/arrows/arr063.svg'
                    className='svg-icon-3 ms-2 me-0'
                />
                <span style={{marginLeft: '0.5rem'}}>Cancelar</span>
                
            </button>

            <button
                type='button'
                className='btn btn-lg btn-primary'
                disabled={loading}
                //data-kt-stepper-action='submit'
                onClick={() => void handleUpdatePlantClick()}
            >
                Atualizar
                {
                    loading ? 
                    <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                    :
                    <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-2 me-0'
                    />
                }
            </button>
        </div>

        <ModalExportDataPrognosis
          show={showCreateAppModalExport}
          data={data}
          handleClose={() => {
            setShowCreateAppModalExport(false)
            //refresh()
          }}
          formikUpdate={formik} 
        />

      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalUpdatePlant}
